// https://github.com/domgen/dgx-myaccount-identity-service/blob/develop/docs/v2/identity-service.openapi.yaml
export const EMAIL_ADDRESS_REG_EXP = new RegExp(
  /^[a-zA-Z0-9]{1}[a-zA-Z0-9.+-_]*@[a-zA-Z0-9]{1}[a-zA-Z0-9.-]*[a-zA-Z0-9]{1}[.][a-zA-Z]{2,}$/
);
